import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
import { withTranslation } from 'react-i18next';
import { ComponentType } from 'react';

import { RootState } from 'store/rootReducer';
import { Dispatch } from 'models/meta/action';
import { requestNavigation } from 'store/navigation/actions';

import { TransactionsPageDispatchProps, TransactionsPageStateProps } from './TransactionsPage.types';
import TransactionsPage from './TransactionsPage.layout';


const mapStateToProps = (state: RootState): TransactionsPageStateProps => ({ userData: state.currentUser.userData });
const mapDispatchToProps = (dispatch: Dispatch): TransactionsPageDispatchProps => ({
    dispatchRequestNavigation: ({ locationPathname, meta }) => dispatch(requestNavigation({ locationPathname, meta })),
    //
});

const decorate = compose<ComponentType>(
    withTranslation('common'),
    connect(mapStateToProps, mapDispatchToProps),
);

export default decorate(TransactionsPage);
